// extracted by mini-css-extract-plugin
module.exports = {"container":"Slogan_container__2Imte","limiter":"Slogan_limiter__2ve7X","title":"Slogan_title__146Op","sub":"Slogan_sub__kxUF5"};